
// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Home from "./ducklin/Home";
// import Navbar from './ducklin/Navbar'; 
// import KnowMoreButton from './ducklin/KnowMoreButton'
// import AllServices from "./ducklin/AllServices";
// import MainAbout from "./ducklin/MainAbout";
// import './App.css'
// import NewsTrend from "./ducklin/NewsTrendMain";
// import Contact from "./ducklin/Contact" 
// import MainProduct from "./ducklin/MainProduct";
// import Footer from "./ducklin/Footer";
// import Electronics from "./ducklin/subproduct/Electronics";
// import PartsComponent from "./ducklin/subproduct/PartComponents";
// import Textile from './ducklin/subproduct/Textile'
// import  HomeAppliances  from "./ducklin/subproduct/HomeAppliances";
// import FashionApparel from "./ducklin/subproduct/FashionApparel";
// import AutomobilePart from "./ducklin/subproduct/AutomobilePart";
// import ScrollToTop from "./ducklin/ScrollToTop";
// function App() {
//   return (
//       <div> 
// <Navbar/>
// <KnowMoreButton/>
// <ScrollToTop/>
//       <Routes>  
//         <Route path="/" element={<Home/>} />
//         <Route path="/services" element={<AllServices/>} />
//         <Route path="/about" element={<MainAbout/>} />
// <Route path="/news"  element={<NewsTrend/>}/>
// <Route path="/products" element={<MainProduct/>} />
// <Route path="/contact" element={<Contact/>}></Route>   
//       <Route path="/homeappliances" element={<HomeAppliances/>} />
//       <Route path="/electronics" element={<Electronics/>} />
//        <Route path="/textile" element={<Textile/>}/>
//        <Route path="/partcomponents" element={<PartsComponent/>}/>
//        <Route path="/fashion" element={<FashionApparel/>}/>
//        <Route path="/automobiles" element={<AutomobilePart/>}/>


//       {/* <Route path="/product1sub" element={<Product1Sub></Product1Sub>}/> */}
//       </Routes>
//      <Footer/>
 
//     </div>
//   );
// }

// export default App;























import React, { Suspense, lazy } from "react";
import { Routes, Route,useLocation } from "react-router-dom";
import Navbar from './ducklin/Navbar'; 
import { useEffect } from "react";
import KnowMoreButton from './ducklin/KnowMoreButton';
import ScrollToTop from "./ducklin/ScrollToTop";
import WhatsAppFloat from './ducklin/WhatsAppFloat'
import './App.css';
import AOS from "aos";
import "aos/dist/aos.css";
import forlazy from './ducklin/Iphone-spinner-2.gif'
import Data from "./ducklin/Data";
const Home = lazy(() => import("./ducklin/Home"));
const AllServices = lazy(() => import("./ducklin/AllServices"));
const MainAbout = lazy(() => import("./ducklin/MainAbout"));
const NewsTrend = lazy(() => import("./ducklin/NewsTrendMain"));
const Contact = lazy(() => import("./ducklin/Contact"));
const MainProduct = lazy(() => import("./ducklin/MainProduct"));
const Electronics = lazy(() => import("./ducklin/subproduct/Electronics"));
const PartsComponent = lazy(() => import("./ducklin/subproduct/PartComponents"));
const Textile = lazy(() => import('./ducklin/subproduct/Textile'));
const HomeAppliances = lazy(() => import("./ducklin/subproduct/HomeAppliances"));
const FashionApparel = lazy(() => import("./ducklin/subproduct/FashionApparel"));
const AutomobilePart = lazy(() => import("./ducklin/subproduct/AutomobilePart"));
const Footer = lazy(() => import("./ducklin/Footer"));
function App() {
const location=useLocation();

useEffect(()=>{
    let title="Little Duckling"

  switch(location.pathname){
    case '/services':
      title += ' Services';
      break;

      case '/products':
      title +=' Products'
      break;

      case '/about':
      title +=' About'
      break;

      case '/contact':
      title +=' Contact'
      break;


   }document.title = title;
   
},[location.pathname])

   useEffect(() => {
    AOS.init({
      duration: 800,
      once: false, 
    mirror: true  
    });
  }, []);
  return (
    <div>
      <Navbar />
      <KnowMoreButton />
      <WhatsAppFloat/>
      <ScrollToTop />
      {/* <Suspense fallback={<div className="text-center" style={{marginTop:'50px'}}>Loading...</div>}> */}
            <Suspense fallback={<div className="text-center" style={{marginTop:'50px'}}>
              <img className="img-fluid center" src={forlazy} style={{marginTop:'50px',width:'auto'}}></img>
              </div>}>

        <Routes>


          {/* <Route path="/ducklingdata" element={<Data />} /> */}

          <Route path="/" element={<Home />} />
          <Route path="/services" element={<AllServices />} />
          <Route path="/about" element={<MainAbout />} />
          <Route path="/news" element={<NewsTrend />} />
          <Route path="/products" element={<MainProduct />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/homeappliances" element={<HomeAppliances />} />
          <Route path="/electronics" element={<Electronics />} />
          <Route path="/textile" element={<Textile />} />
          <Route path="/partcomponents" element={<PartsComponent />} />
          <Route path="/fashion" element={<FashionApparel />} />
          <Route path="/automobiles" element={<AutomobilePart />} />
        </Routes>
        <Footer />
      </Suspense>
    </div>
  );
}

export default App;
